import React from "react";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { FaEnvelope } from "react-icons/fa";

interface ImportClientsTableProps {
  clients: any[];
  searchTerm: string;
  setSearchTerm: (v: string) => void;
  startDate: Date | null;
  endDate: Date | null;
  setStartDate: (d: Date | null) => void;
  setEndDate: (d: Date | null) => void;
  isDropdownOpen: boolean;
  setIsDropdownOpen: (v: boolean) => void;
  sortBy: (key: "name" | "firstname" | "email" | "createdAt") => void;
  selectedEmails: Set<string>;
  onToggleEmail: (email: string) => void;
}

const ImportClientsTable: React.FC<ImportClientsTableProps> = ({
  clients,
  searchTerm,
  setSearchTerm,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  isDropdownOpen,
  setIsDropdownOpen,
  sortBy,
  selectedEmails,
  onToggleEmail,
}) => {
  return (
    <div className="ImportEmailTable">
      {/* Filtres */}
      <div className="filters mb-3 d-flex align-items-center gap-3 flex-wrap">
        <input
          type="text"
          placeholder="Rechercher par nom, prénom ou email"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="form-control"
          style={{ maxWidth: "250px" }}
        />

        <div className="d-flex gap-2">
          <DatePicker
            selected={startDate ?? undefined}
            onChange={(d) => setStartDate(d)}
            placeholderText="Date de début"
            className="form-control"
            dateFormat="dd-MM-yyyy"
          />
          <DatePicker
            selected={endDate ?? undefined}
            onChange={(d) => setEndDate(d)}
            placeholderText="Date de fin"
            className="form-control"
            dateFormat="dd-MM-yyyy"
            minDate={startDate ?? undefined}
          />
        </div>

        <div className="position-relative">
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            ☰ Trier par
          </button>

          {isDropdownOpen && (
            <div className="dropdown-menu show">
              <button className="dropdown-item" onClick={() => sortBy("name")}>Nom</button>
              <button className="dropdown-item" onClick={() => sortBy("firstname")}>Prénom</button>
              <button className="dropdown-item" onClick={() => sortBy("email")}>Email</button>
              <button className="dropdown-item" onClick={() => sortBy("createdAt")}>
                Date d'inscription
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="email-table-container mb-3">
        <table className="table">
          <thead>
            <tr>
              <th>Sélectionner</th>
              <th>Nom & Prénoms</th>
              <th>Date d'inscription</th>
              <th>Destinataire ({clients.length})</th>
            </tr>
          </thead>
          <tbody>
            {clients.map((client) => (
              <tr key={client.id}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedEmails.has(client.email)}
                    onChange={() => onToggleEmail(client.email)}
                  />
                </td>
                <td>{client.name} {client.firstname}</td>
                <td>{format(new Date(client.createdAt), "dd/MM/yyyy")}</td>
                <td>
                  <div className="d-flex align-items-center">
                    <FaEnvelope />
                    <span className="ms-2">{client.email}</span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ImportClientsTable;
